import CitySEOHead from "@/components/feature/CitySEOHead";
import DelrayHeroSection from "./components/HeroSection";
import DelrayStickyNav from "./components/StickyNav";
import DelrayProcessingTimeSection from "./components/ProcessingTimeSection";
import DelrayServicesSection from "./components/ServicesSection";
import DelrayLocalAreaSection, { landmarks as delrayLandmarks } from "./components/LocalAreaSection";
import DelrayTestimonialsSection from "./components/TestimonialsSection";
import DelrayAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import DelrayComparisonSection from "./components/ComparisonSection";
import DelrayMistakesSection from "./components/MistakesSection";
import DelrayHowItWorksSection from "./components/HowItWorksSection";
import DelrayFAQSection, { faqs } from "./components/FAQSection";
import DelrayHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import DelrayFinalCTA from "./components/FinalCTA";
import DelrayTravelTimingSection from "./components/TravelTimingSection";
import DelrayDestinationsSection from "./components/DestinationsSection";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Delray Beach, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Delray Beach, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving South Florida travelers.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

const areaServedList = [
  { "@type": "City", name: "Delray Beach" },
  { "@type": "City", name: "Boca Raton" },
  { "@type": "City", name: "Boynton Beach" },
  { "@type": "City", name: "West Palm Beach" },
  { "@type": "City", name: "Lake Worth Beach" },
  { "@type": "City", name: "Deerfield Beach" },
  { "@type": "City", name: "Wellington" },
  { "@type": "City", name: "Highland Beach" },
  { "@type": "AdministrativeArea", name: "Palm Beach County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Delray Beach, Boca Raton, Boynton Beach, and Palm Beach County with expedited passport processing as fast as 24 hours. A+ BBB rated. Located at 401 W Atlantic Ave #351 near Atlantic Avenue.";

export default function DelrayPage() {
  return (
    <>
      <CitySEOHead
        city="Delray Beach"
        state="Florida"
        stateAbbr="FL"
        route="/cities/delray-beach"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Delray Beach, Florida"
        geoPosition="26.4615;-80.0728"
        keywords="expedited passport Delray Beach, emergency passport Delray Beach FL, same day passport Delray Beach, fast passport South Florida, passport renewal Delray Beach, Delray Beach passport courier"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        hasPhysicalOffice
        lastModified="2026-07-17"
        ogImage="https://readdy.ai/api/search-image?query=Professional%20office%20building%20exterior%20in%20Delray%20Beach%20Florida%20with%20modern%20glass%20facade%20and%20palm%20trees%2C%20warm%20sunny%20afternoon%2C%20clean%20architectural%20lines%2C%20tropical%20landscaping%2C%20blue%20sky%2C%20upscale%20commercial%20building%20in%20suburban%20Palm%20Beach%20County%20setting%2C%20bright%20natural%20lighting&width=1200&height=630&seq=delray-og-2026&orientation=landscape"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={delrayLandmarks}
      />
      <div className="font-sans">
        <DelrayHeroSection />
        <DelrayStickyNav />
        <DelrayLocalAreaSection />
        <DelrayProcessingTimeSection />
        <DelrayServicesSection />
        <DelrayTravelTimingSection />
        <DelrayDestinationsSection />
        <DelrayTestimonialsSection />
        <DelrayAcceptanceFacilitiesSection />
        <DelrayComparisonSection />
        <DelrayMistakesSection />
        <DelrayHowItWorksSection />
        <DelrayFAQSection />
        <DelrayHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/delray-beach" state="FL" />
        <DelrayFinalCTA />
      </div>
    </>
  );
}